PJQ.Draggable = class {
	constructor($el, options = {}) {
		let self = this;
		self.$el = $el;
		self.options = _.defaults(options, {
			addClasses: "selected",
			stop: function () {
				self.onStop();
			}
		});
		if (_.size(self.$el) > 0) {
			self.$el.draggable(self.options);
		}
	}

	onStop() {
		if (typeof this.options.onStop === 'function') {
			this.options.onStop();
		}
	}
};

PJQ.Droppable = class {
	constructor($el, options = {}) {
		let self = this;
		self.$el = $el;
		self.options = _.defaults(options, {
			addClasses: "selected",
			stop: function () {
				self.onStop();
			}
		});
		if (_.size(self.$el) > 0) {
			self.$el.droppable(self.options);
		}
	}

	onStop() {
		if (typeof this.options.onStop === 'function') {
			this.options.onStop();
		}
	}
};